import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    cardBrandDetails: undefined,
    lastError: null,
};

export const callTypes = {
    list: "list",
    action: "action",
};

export const cardBrandSlice = createSlice({
    name: "cardBrand",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getcardbrands
        cardBrandsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.entities = entities;
            state.totalCount = totalCount;
            state.error = null;
        }, // getcardbrands
        officeFetched: (state, action) => {
            const { entities } = action.payload;
            state.listLoading = false;
            state.offices = entities;
            state.error = null;
        },
        //getcardbrandDetails
        cardBrandDetailsFetched: (state, action) => {
            const { cardBrandDetails } = action.payload;
            state.actionsLoading = false;
            if(cardBrandDetails) delete cardBrandDetails.password;
            // if(cardBrandDetails ) delete cardBrandDetails.service_password;
            state.cardBrandDetails = cardBrandDetails;
            state.error = null;
        },
        // updatecardbrand
        cardBrandUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            // state.cardBrandDetails = action.payload.cardBrand;
        },
        cardBrandCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            // state.entities.push(action.payload.customer); //push in existing list
        },
        // deletecardbrand
        cardBrandDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.filter(
                (el) => el._id !== action.payload.cardBrand_id
            );
        },
    },
});
